import React, { Component, Fragment } from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import MasterPackageH2Header from "./MasterPackageH2Header";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { v4 as uuidv4 } from "uuid";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { initialDataDetail, tableColumns } from "../config/config";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { getCategoryType, getDataDetail, validateDataItem } from "../util";
import { fetchDataItem } from "../service";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";

class MasterPackageH2Modifying extends Component {
  constructor(props) {
    super(props);
    this.listDataName = { Job: "service", Part: "part" };
    this.listTabPanel = ["Job", "Part"];
    this.state = {
      loading: false,
      warningModalVisible: false,
      activeTab: "Job",
      prevVariants: [],
      errorListCabang: undefined,
      errorGracePeriod: undefined,
      errorStartDate: undefined,
      errorEndDate: undefined,
      errorGracePeriods: undefined,
      tableColumn: [],
      dataTable: {
        Job: [],
        Part: [],
      },
      dataDetailSaved: {
        Job: [],
        Part: [],
      },
      selectedRow: null,
      dataCategory: [],
      dataItem: [],
      pagination: {
        Job: {
          page: 1,
          limit: 5,
          totalData: 0,
        },
        Part: {
          page: 1,
          limit: 5,
          totalData: 0,
        },
      }
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    Object.entries(this.listDataName).forEach(([key, value]) => {
      this.props.setValue(value, this.state.dataDetailSaved[key]);
    });

    if (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)) {
      const id = await this.fetchMasterPackageId();
      this.props.setValue("packageId", id);
    }

    if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
      await this.fetchDataDetail();
    }

    const categoryType = getCategoryType(this.state.activeTab);
    const listCategory = await this.fetchDataCategory({
      paramFilters: { bizparCategory: categoryType },
    });
    this.setState({
      tableColumn: tableColumns.detailPage(
        this.handleSaveRow,
        this.handleEditRow,
        this.handleCancelRow,
        this.handleDeleteRow,
        this.handleValueChange,
        this.handleCategoryChange,
        this.handleItemChange,
        listCategory,
        this.state.dataItem,
        this.state.validationErrors,
        this.state.activeTab
      )[this.state.activeTab],
      dataCategory: listCategory,
    });

    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (prevState.dataTable !== this.state.dataTable) {
      Object.entries(this.listDataName).forEach(([key, value]) => {
        this.props.setValue(value, this.state.dataDetailSaved[key]);
      });
    }

    if (prevState.activeTab !== this.state.activeTab) {
      this.handleTriggerLoading();
      const categoryType = getCategoryType(this.state.activeTab);
      const listCategory = await this.fetchDataCategory({
        paramFilters: { bizparCategory: categoryType },
      });
      this.setState((prevState) => ({
        ...prevState,
        tableColumn: tableColumns.detailPage(
          this.handleSaveRow,
          this.handleEditRow,
          this.handleCancelRow,
          this.handleDeleteRow,
          this.handleValueChange,
          this.handleCategoryChange,
          this.handleItemChange,
          listCategory,
          this.state.dataItem,
          this.state.validationErrors,
          this.state.activeTab
        )[this.state.activeTab],
        dataCategory: listCategory,
      }));
      this.handleTriggerLoading();
    }

    if (prevState.dataItem !== this.state.dataItem) {
      this.setState((prevState) => ({
        ...prevState,
        tableColumn: tableColumns.detailPage(
          this.handleSaveRow,
          this.handleEditRow,
          this.handleCancelRow,
          this.handleDeleteRow,
          this.handleValueChange,
          this.handleCategoryChange,
          this.handleItemChange,
          prevState.dataCategory,
          prevState.dataItem,
          this.state.validationErrors,
          this.state.activeTab
        )[this.state.activeTab],
      }));
    }

    if (prevState.validationErrors !== this.state.validationErrors) {
      this.setState((prevState) => ({
        ...prevState,
        tableColumn: tableColumns.detailPage(
          this.handleSaveRow,
          this.handleEditRow,
          this.handleCancelRow,
          this.handleDeleteRow,
          this.handleValueChange,
          this.handleCategoryChange,
          this.handleItemChange,
          prevState.dataCategory,
          prevState.dataItem,
          this.state.validationErrors,
          this.state.activeTab
        )[this.state.activeTab],
      }));
    }
  };

  handleWarningModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  handleSubmit = () => {
    let valid = true;
    if (!this.props.validate()) {
      valid = false;
    }

    if (!this.validateListCabang()) {
      valid = false;
    }

    if (!this.validateGracePeriod()) {
      valid = false;
    }

    if (!this.validatePartAndService()) {
      valid = false;
    }

    if (valid) {
      // console.log(this.props.controls);

      this.props.onSubmit(this.props.controls);
    }
  };

  // handleAddRow = async () => {
  //   const { activeTab } = this.state;
  //   const template = initialDataDetail?.[activeTab] || {};

  //   const newData = {
  //     id: uuidv4(),
  //     ...template,
  //   };

  //   this.setState(
  //     (prevState) => {
  //       const prevDataTable = prevState.dataTable || {};
  //       const prevTabArray = Array.isArray(prevDataTable[activeTab])
  //         ? prevDataTable[activeTab]
  //         : [];

  //       return {
  //         ...prevState,
  //         dataTable: {
  //           ...prevDataTable,
  //           [activeTab]: [...prevTabArray, newData],
  //         },
  //       };
  //     },
  //     async () => {
  //       const currentData = this.state.dataTable?.[activeTab] || [];
  //       const newIndex = currentData.length - 1;

  //       await this.fetchDataItem(newIndex);
  //     }
  //   );
  // };

  handleAddRow = async () => {
    this.setState(
      (prev) => {
        const { activeTab } = prev;

        // template default sesuai tab
        const template = initialDataDetail?.[activeTab] || {};

        const newRow = {
          id: uuidv4(),
          saved: false,
          ...template,
        };

        const prevTable = prev.dataTable?.[activeTab] || [];
        const newIndex = prevTable.length;

        return {
          ...prev,
          dataTable: {
            ...prev.dataTable,
            [activeTab]: [...prevTable, newRow],
          },
          dataItem: {
            ...prev.dataItem,
            [activeTab]: {
              ...(prev.dataItem?.[activeTab] || {}),
              [newIndex]: [], // siapkan slot dropdown utk row baru
            },
          },
        };
      },
      async () => {
        const { activeTab, dataTable } = this.state;
        const newIndex = (dataTable?.[activeTab] || []).length - 1;

        // fetch options utk row baru
        await this.fetchDataItem(newIndex);
      }
    );
  };

  handleSaveRow = (index) => {
    const { activeTab, dataTable } = this.state;
    const rowData = dataTable[activeTab][index];
    const errors = validateDataItem(rowData, activeTab);

    if (!R.isNil(errors) && !R.isEmpty(errors)) {
      this.setState({ validationErrors: errors });
      return;
    }

    const getUniqueCode = (item) => {
      switch (activeTab) {
        case "Job":
          return item.serviceCode?.value;
        case "Part":
          return item.kodePart?.value || item.partCode || item.kode;
        default:
          return item.kode;
      }
    };

    const duplicateIndex = dataTable[activeTab].findIndex((item, i) => {
      if (i === index) return false;
      return (
        getUniqueCode(item) && getUniqueCode(item) === getUniqueCode(rowData)
      );
    });

    if (duplicateIndex !== -1) {
      this.handleWarningModalVisibility(
        "Data sudah terdapat pada list. Mohon dicek kembali"
      );
      return;
    }

    this.setState((prevState) => {
      const currentData = [...prevState.dataTable[activeTab]];
      currentData[index] = {
        ...currentData[index],
        saved: !currentData[index].saved,
      };

      let updatedData = currentData;
      if (activeTab === "Part") {
        updatedData = Array.from(
          currentData
            .reduce((map, item) => {
              const key = getUniqueCode(item);
              if (!key) return map;

              const existing = map.get(key);
              if (existing) {
                existing.partQty += Number(item.partQty || 0);
              } else {
                map.set(key, {
                  ...item,
                  partQty: Number(item.partQty || 0),
                });
              }
              return map;
            }, new Map())
            .values()
        );
      }

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: updatedData,
        },
        dataDetailSaved: {
          ...prevState.dataDetailSaved,
          [activeTab]: updatedData,
        },
        validationErrors: {},
      };
    });
  };

  handleEditRow = async (index) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      const savedPrevValue = newState[index];
      newState[index] = {
        ...newState[index],
        saved: !newState[index].saved,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
        selectedRow: {
          ...prevState.selectedRow,
          [this.state.activeTab]: {
            ...prevState.selectedRow?.[this.state.activeTab],
            [index]: savedPrevValue,
          },
        },
      };
    });

    const categoryId =
      this.state.dataTable[this.state.activeTab][index].category?.value;
    await this.fetchDataItem(index, categoryId);
  };

  handleCancelRow = (index) => {
    this.setState((prevState) => {
      let dataTable = prevState.dataTable[this.state.activeTab];
      if (
        R.isNil(prevState.selectedRow) ||
        R.isEmpty(prevState.selectedRow) ||
        R.isEmpty(prevState.selectedRow?.[this.state.activeTab])
      ) {
        dataTable = [
          ...prevState.dataTable[this.state.activeTab].filter(
            (_, idx) => idx !== index
          ),
        ];
      } else {
        dataTable[index] = Object.values(
          prevState.selectedRow[this.state.activeTab]
        ).find((item) => item.id === dataTable[index].id);
      }

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: dataTable,
        },
        selectedRow:
          !R.isNil(prevState.selectedRow) && !R.isEmpty(prevState.selectedRow)
            ? {
                ...prevState.selectedRow,
                [this.state.activeTab]: Object.values(
                  prevState.selectedRow[this.state.activeTab]
                ).filter((item) => item.id !== dataTable[index].id),
              }
            : null,
      };
    });
  };

  handleDeleteRow = (index) => {
    this.setState((prevState) => ({
      ...prevState,
      dataTable: {
        ...prevState.dataTable,
        [this.state.activeTab]: [
          ...prevState.dataTable[this.state.activeTab].filter(
            (_, idx) => idx !== index
          ),
        ],
      },
      dataDetailSaved: {
        ...prevState.dataDetailSaved,
        [this.state.activeTab]: [
          ...prevState.dataDetailSaved[this.state.activeTab].filter(
            (_, idx) => idx !== index
          ),
        ],
      },
    }));
  };

  handleValueChange = (index, name, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      newState[index] = {
        ...newState[index],
        [name]: value,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
      };
    });
  };

  handleCategoryChange = async (index, name, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      newState[index] = {
        ...newState[index],
        [name]: value,
        name: null,
        kode: null,
        satuan: null,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
      };
    });

    this.handleTriggerLoading();
    await this.fetchDataItem(index, value.value);
    this.handleTriggerLoading();
  };

  handleTabChange = (index) => {
    const selectedTab = this.listTabPanel?.[index] ?? "Job";

    this.setState((prev) => ({
      ...prev,
      activeTab: selectedTab,
      pagination: {
        ...prev.pagination,
        [selectedTab]: {
          ...prev.pagination[selectedTab],
          page: 1,
          limit: 5, 
        },
      },
    }));
  };

  validateListCabang = () => {
    const { allCabang: allCabang, kodeCabang } = this.props.controls;
    if (
      !allCabang.value &&
      (R.isNil(kodeCabang.value) || kodeCabang.value.length === 0)
    ) {
      this.setState({ errorListCabang: "Field belum diisi" });
      return false;
    }

    this.setState({ errorListCabang: null });
    return true;
  };

  validatePartAndService = () => {
    const { part, service } = this.props.controls;

    const isPartEmpty = !Array.isArray(part?.value) || part.value.length === 0;
    const isServiceEmpty =
      !Array.isArray(service?.value) || service.value.length === 0;

    if (isPartEmpty && isServiceEmpty) {
      this.handleWarningModalVisibility("Terdapat data yang belum lengkap");
      return false;
    }

    return true;
  };

  validateGracePeriod = () => {
    const { hasGracePeriod, startDate, endDate, gracePeriod } =
      this.props.controls;
    let valid = true;
    if (!hasGracePeriod?.value) {
      if (R.isNil(startDate?.value)) {
        this.setState({ errorStartDate: "Field belum diisi" });
        valid = false;
      } else {
        this.setState({ errorStartDate: null });
      }
      if (R.isNil(endDate?.value)) {
        this.setState({ errorEndDate: "Field belum diisi" });
        valid = false;
      } else {
        this.setState({ errorEndDate: null });
      }
      if (
        R.isNil(gracePeriod?.value) ||
        String(gracePeriod.value).trim() === ""
      ) {
        this.setState({ errorGracePeriods: "Field belum diisi" });
        valid = false;
      } else {
        this.setState({ errorGracePeriods: null });
      }
    } else {
      this.setState({ errorStartDate: null });
      this.setState({ errorEndDate: null });
    }
    return valid;
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchMasterPackageId = async () => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).generateMasterPackageH2Id();
      return res.ok ? res.data.data : null;
    } catch (error) {
      // console.log("error: ", error);
    }
  };

  fetchDataDetail = async () => {
    let id = this.props.controls.packageId.value;
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterPackageH2ById,
      menuName: "Master Package H23",
      setError: this.props.setError,
      args: contructQueryParam({ packageId: id }),
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const listVariant = res.data.data.kodeVariant?.map((item) =>
        mapToObjectDDL(item.kodeVariant, item.kodeVariant)
      );
      this.props.setValue("kodeVariant", listVariant);

      if (R.equals(this.props.controls.kodeCabang.value, "ALL")) {
        this.props.setValue("allCabang", true);
        this.props.setValue("listCabang", []);
      } else {
        const listCabang = res.data.data.kodeCabang?.map((item) =>
          mapToObjectDDL(item.namaDealer, item.kodeCabang)
        );
        this.props.setValue("allCabang", false);
        this.props.setValue("kodeCabang", listCabang);
      }

      this.props.setValue("gracePeriod", res.data.data?.gracePeriod);
      this.props.setValue("hasGracePeriod", res.data.data.hasGracePeriod);
      this.props.setValue("startDate", res.data.data.startDate);
      this.props.setValue("endDate", res.data.data.endDate);

      this.setState((prevState) => ({
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          Job: getDataDetail("Job", res.data.data.service || []),
          Part: getDataDetail("Part", res.data.data.part || []),
        },
        dataDetailSaved: {
          ...prevState.dataDetailSaved,
          Job: getDataDetail("Job", res.data.data.service || []),
          Part: getDataDetail("Part", res.data.data.part || []),
        },
        pagination: {
            ...prevState.pagination,
            totalData: res.data.data.length,
        }
      }));
    }
  };

  fetchDataCategory = async (body) => {
    try {
      const res = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam(
        body
      );
      if (res.ok) {
        return res.data.data;
      }
    } catch (error) {
      // console.log("errors: ", error);
    }

    return null;
  };

  // fetchDataItem = async (index, body = {}) => {
  //   const { activeTab } = this.state;
  //   const { controls } = this.props;

  //   try {
  //     const finalBody =
  //       activeTab === "Job"
  //         ? {
  //             ...body,
  //             kodeVariant: controls?.kodeVariant?.value?.map(
  //               (item) => item.value
  //             ),
  //           }
  //         : body;

  //     const res = await fetchDataItem(activeTab, finalBody);
  //     this.setState((prevState) => ({
  //       ...prevState,
  //       dataItem: {
  //         ...prevState.dataItem,
  //         [activeTab]: {
  //           ...prevState.dataItem?.[activeTab],
  //           [index]: res,
  //         },
  //       },
  //     }));
  //   } catch (error) {}
  // };

  fetchDataItem = async (index, body = {}) => {
    const { activeTab } = this.state;
    const { controls } = this.props;

    try {
      const finalBody =
        activeTab === "Job"
          ? {
              ...body,
              kodeVariant: controls?.kodeVariant?.value?.map((v) => v.value),
            }
          : body;

      const res = await fetchDataItem(activeTab, finalBody);

      this.setState((prev) => {
        const prevTab = prev.dataItem?.[activeTab] ?? {};

        return {
          ...prev,
          lastFetchResult: res,
          dataItem: {
            ...prev.dataItem,
            [activeTab]: {
              ...prevTab,
              [activeTab === "Job" ? 0 : index]: Array.isArray(res) ? res : [],
            },
          },
        };
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleItemChange = (rowIndex, name, selected) => {
    this.setState((prev) => {
      const activeTab = this.state.activeTab;
      const dataTable = [...prev.dataTable[activeTab]];
      const updatedRow = { ...dataTable[rowIndex] };

      if (activeTab === "Job") {
        if (name === "serviceCode") {
          updatedRow.serviceCode = selected
            ? { label: selected.value, value: selected.value }
            : null;

          if (selected) {
            updatedRow.serviceCategory = selected.serviceCategory || "";
            updatedRow.estimationTime = selected.estimationTime || "";
            updatedRow.serviceName = {
              label: selected.label,
              value: selected.value,
            };
          }
        }

        if (name === "serviceName") {
          updatedRow.serviceName = selected
            ? { label: selected.label, value: selected.value }
            : null;

          if (selected) {
            updatedRow.serviceCategory = selected.serviceCategory || "";
            updatedRow.estimationTime = selected.estimationTime || "";
            updatedRow.serviceCode = {
              label: selected.value,
              value: selected.value,
            };
          }
        }
      }

      if (activeTab === "Part") {
        if (name === "kodePart") {
          updatedRow.kodePart = selected
            ? { label: selected.value, value: selected.value }
            : null;

          if (selected) {
            updatedRow.partCategory = selected.partCategory || "";
            updatedRow.satuan = selected.satuan || "";
            updatedRow.partName = {
              label: selected.label,
              value: selected.value,
            };
          }
        }

        if (name === "partName") {
          updatedRow.partName = selected
            ? { label: selected.label, value: selected.value }
            : null;

          if (selected) {
            updatedRow.partCategory = selected.partCategory || "";
            updatedRow.satuan = selected.satuan || "";
            updatedRow.kodePart = {
              label: selected.value,
              value: selected.value,
            };
          }
        }
      }

      dataTable[rowIndex] = updatedRow;

      return {
        dataTable: {
          ...prev.dataTable,
          [activeTab]: dataTable,
        },
      };
    });
  };

  handleClearVariantAndJobs = () => {
    // reset value dropdown variant
    this.props.setValue("kodeVariant", []);

    this.setState((prev) => {
      const jobRows = prev.dataTable?.Job ?? [];
      const clearedJobRows = jobRows.map((row) => ({
        ...row,
        serviceCode: null,
        serviceName: null,
        serviceCategory: "",
        estimationTime: "",
        saved: false,
      }));

      return {
        ...prev,
        dataTable: {
          ...prev.dataTable,
          Job: clearedJobRows,
        },
        dataDetailSaved: {
          ...prev.dataDetailSaved,
          Job: clearedJobRows,
        },
        dataItem: {
          ...prev.dataItem,
          Job: {},
        },

        validationErrors: {},
      };
    });
  };

  handleVariantChange = async (value) => {
    const { activeTab, prevVariants } = this.state;
    const newList = value || [];
    const oldList = prevVariants || [];

    this.props.setValue("kodeVariant", newList);

    const newLength = newList.length;
    const oldLength = oldList.length;

    if (newLength < oldLength && activeTab === "Job") {
      console.log("REMOVE DETECTED");

      const payload = {
        kodeVariant: newList.map((item) => item.value),
      };

      const res = await fetchDataItem("Job", payload);
      const validCodes = (res || []).map((item) => item.value);

      this.setState((prev) => {
        const jobRows = prev.dataTable?.Job ?? [];
        const updatedRows = jobRows.filter((row) => {
          const code = row?.serviceCode?.value;
          if (!code) return false; 
          return validCodes.includes(code); 
        });

        return {
          ...prev,
          dataTable: {
            ...prev.dataTable,
            Job: updatedRows,
          },
        };
      });
    }

    if (newLength > oldLength && activeTab === "Job") {
      this.fetchDataItem(0, {
        kodeVariant: newList.map((v) => v.value),
      });
    }

    this.setState({ prevVariants: newList });
  };

  handleChangePage = (tableState) => {
    const { activeTab } = this.state;

    this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        [activeTab]: {
          ...prev.pagination[activeTab],
          page: tableState.page + 1,
        },
      },
    }));
  };
  handleRowsPerPage = (tableState) => {
    const { activeTab } = this.state;

    this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        [activeTab]: {
          ...prev.pagination[activeTab],
          page: 1,
          limit: tableState.rowsPerPage,
        },
      },
    }));
  };

  render() {
    const { activeTab, pagination } = this.state;
    const currentPagination = pagination[activeTab];
    return (
      <>
        <SimpleModal
          title="Detail Package"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <MasterPackageH2Header
                {...this.props}
                activeTab={this.state.activeTab}
                onVariantChange={(value) => this.handleVariantChange(value)}
                // onVariantChange={(value) => {
                //   this.props.setValue("kodeVariant", value);
                //   console.log(value);

                //   if (this.state.activeTab === "Job") {
                //     this.fetchDataItem(0, { kodeVariant: value });
                //   }
                // }}
                onClearVariant={this.handleClearVariantAndJobs}
                errorListCabang={this.state.errorListCabang}
                errorStartDate={this.state.errorStartDate}
                errorEndDate={this.state.errorEndDate}
                errorGracePeriod={this.state.errorGracePeriods}
              />

              <Tabs onSelect={(index) => this.handleTabChange(index)}>
                <TabList>
                  {this.listTabPanel.map((tab, index) => (
                    <Tab
                      key={index}
                      id={`button_navigate_${tab.toLowerCase()}`}
                    >
                      {tab}
                    </Tab>
                  ))}
                </TabList>
                {this.listTabPanel.map((item, index) => {
                  return (
                    <TabPanel key={`${index}-${item}`}>
                      <FlexView
                        vAlignContent="center"
                        className="margin-bottom-10px"
                      >
                        <SimpleButton
                          className={
                            "btn btn-plus background-red margin-left-none"
                          }
                          onClick={this.handleAddRow}
                          icon={
                            <i className="fa fa-plus margin-right-10px"></i>
                          }
                          text={`Tambah ${item}`}
                        />
                      </FlexView>
                      <SimpleDataTable
                        key={`${currentPagination.totalData}-${currentPagination.page}-${activeTab}`}
                        data={this.state.dataTable[activeTab]}
                        columns={this.state.tableColumn}
                        validationErrors={this.state.validationErrors}
                        toCount={currentPagination.totalData}
                        rowsPerPage={currentPagination.limit}
                        page={currentPagination.page - 1}
                        options={{
                          ...defaultTableChange(this.handleChangePage, this.handleRowsPerPage),
                          serverSide: false,
                        }}
                      />
                    </TabPanel>
                  );
                })}
              </Tabs>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <SimpleButton
                  text="Simpan"
                  type="button"
                  onClick={() => this.handleSubmit()}
                />
              </div>
            </ModalContainer>
          }
        />

        {this.state.warningModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>
                  {this.state.warningMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            additionalButtons={
              <Fragment>
                <FlexView>
                  <SimpleButton
                    text="OK"
                    secondary
                    onClick={() => this.handleWarningModalVisibility()}
                  />
                </FlexView>
              </Fragment>
            }
            visible={this.state.warningModalVisible}
            onClickClose={this.handleWarningModalVisibility}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default withFormGroup(MasterPackageH2Modifying);
